import { Interpolation, Theme, css } from '@emotion/react'

export const block = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  margin-top: 24px;
`

export const title: Interpolation<Theme> = (theme) => css`
  color: ${theme.typographyColors.typographyTwo};
  font-weight: 700;
  margin: 24px 0;
`

export const divider: Interpolation<Theme> = (theme) => css`
  width: 100%;
  height: 1px;
  background-color: ${theme.colors.backgroundOne};
`

export const textArea: Interpolation<Theme> = css`
  line-height: 24px;
  resize: vertical;
`
